export default {
  methods: {
    contactFullName(contact) {
      return (contact.last_name ?? '') + ' ' + (contact.first_name ?? '') + ' ' + (contact.middle_name ?? '');
    },
    fullContact(contact) {
      if (!contact) return '';
      let name = this.contactFullName(contact);
      let ret = (name.trim() === "") ? this.formatPhone(contact.phone) : (name + ' ' + this.formatPhone(contact.phone)); // Phone if name is empty
      return (!ret || ret.trim() === "") ? contact.email : ret; // email if name and phone are empty
    },
    formatPhone(str) {
      let cleaned = ('' + str).replace(/\D/g, '');
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{2})(\d{2})$/);

      if (match) {
        return '+7 (' + match[1] + ') ' + match[2] + '-' + match[3] + '-' + match[4];
      }

      return str;
    },
    inIframe() {
      return !(window === window.parent)
    }
  }
};
